import { useMemo } from 'react';
import { useFeatureFlags } from './useFeatureFlags';

export const useRouteLogic = () => {
  const { dailyTipperEnabled, cookiesEnabled, me, userSettings } = useFeatureFlags();

  const shouldShowDailyTipper = useMemo(() => {
    return (
      dailyTipperEnabled && ((cookiesEnabled && userSettings?.isCookieAccepted) || !cookiesEnabled)
    );
  }, [dailyTipperEnabled, cookiesEnabled, userSettings]);

  const shouldRedirectToConfirmEmail = useMemo(() => {
    const query = new URLSearchParams(window.location.search);
    return me?.confirmationToken && window.location && !query.get('token');
  }, [me]);

  return {
    shouldShowDailyTipper,
    shouldRedirectToConfirmEmail,
  };
};
